import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from "react-router-dom"
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { Auth0ProviderWithNavigate } from "./utils/auth0-provider-with-navigate";
// import * as dotenv from 'dotenv'
import {ContextWrapper} from './context'

const container = document.getElementById("root")
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <ContextWrapper>
      <BrowserRouter>
        {/* <Auth0ProviderWithNavigate> */}
          <App/>
        {/* </Auth0ProviderWithNavigate> */}
      </BrowserRouter>
    </ContextWrapper>
  </React.StrictMode>
)

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
